import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';

import Header from './Header.js';

import './App.css';

function PageSuccess() {
  useStores([SessionStore]);

  return (
    <>
      <Header />
      <div className="middle large">
        That’s the right note!
      </div>
      <div className="bottom">
        <div class="buttons">
          <button
            onClick={() => {
              SessionStore.nextCard();
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
}

export default PageSuccess;
